import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[carm-alphanumeric-only]',
  standalone: true
})
export class AlphanumericOnlyDirective {
  @Input('carm-alphanumeric-only') enabled: boolean | '' = true;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private ngControl: NgControl
  ) {}

  private isEnabled(): boolean {
    return this.enabled === '' || !!this.enabled;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (!this.isEnabled()) return;
    const input = this.el.nativeElement;
    const initialValue = input.value;
    const cleaned = initialValue.replace(/[^a-zA-Z0-9]/g, '');

    if (cleaned !== initialValue) {
      // fix the DOM
      input.value = cleaned;
      // fix the FormControl value
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(cleaned);
      }

      event.stopPropagation();
    }
  }
}
